import programService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    loading: false,
    programs: [],
    working: false,
    pagination: { current_page: 1 },
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
    programs(state) {
      return state.programs;
    },
    pagination(state) {
      return state.pagination;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setPrograms(state, payload) {
      state.programs = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },
  actions: {
    async getPrograms({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await programService.fetchPrograms(payload);
        commit("setPrograms", res.data.data);
        commit("setPagination", res.data.pagination);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async editProgram({ commit, dispatch, state }, payload) {
      commit("setWorking", true);
      try {
        const res = await programService.updateProgram(payload);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        await dispatch("getPrograms", { page: state.pagination.current_page });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    async addProgram({ commit, dispatch, state }, payload) {
      commit("setWorking", true);
      try {
        const res = await programService.saveProgram(payload);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        await dispatch("getPrograms", { page: state.pagination.current_page });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteProgram({ commit, dispatch }, id) {
      commit("setLoading", true);
      try {
        const res = await programService.deleteProgram(id);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        await dispatch("getPrograms", { page: 1 });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setLoading", false);
      }
    },

    async getNgoRelatedServices({ commit }) {
      commit("setLoading", true);
      try {
        const res = await programService.fetchServices();
        commit("setPrograms", res.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
